/**
 * Remove caracteres invisíveis (BOM, zero-width) e troca espaços Unicode (ex: NBSP) por espaço comum, preservando a separação entre palavras ("Maria\u00A0Silva" → "Maria Silva").
 */
function removerCaracteresInvisiveisEPadronizarEspacos(valor: string): string {
  return valor
    .replace(/[\uFEFF\u200B-\u200D\u2060]/g, "")
    .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, " ")
    .trim();
}

/**
 * EXPORTS
 */
export { removerCaracteresInvisiveisEPadronizarEspacos };
